import { LitElement, html, css } from 'lit'
import { ProgressBar } from './progress-bar'
import { centsToDollars } from '../../lib/utils'

export class FreeShippingProgress extends LitElement {
  static styles = [
    css`
      :host {
        display: block;
      }

      .free-shipping-progress {
        background-color: #ffffff;
        padding: 6px 20px;
        display: flex;
        flex-direction: column;
        row-gap: 4px;
      }

      .free-shipping-progress[shipping-progress-enabled='false'] {
        display: none;
      }

      .free-shipping-progress p {
        color: #0a0a0a;
        font-size: 12px;
        font-weight: 400;
        line-height: 16.8px;
        text-align: center;
        margin: 0;
        white-space: nowrap;
      }

      .free-shipping-progress-bar progress-bar {
        width: 100%;
        margin: 8px auto;
        font-size: 14px;
        border-radius: 9999px;
        height: 20px;
        background-color: #f4f4f2;
        border: 1px solid #077f61;
      }

      .free-shipping-progress-bar {
        display: flex;
        align-items: center;
        width: 100%;
      }

      .free-shipping-progress-bar .min-num,
      .free-shipping-progress-bar .max-num {
        color: #978f90;
        font-size: 14px;
      }
    `,
  ]

  static properties = {
    subtotal: { type: Number },
    freeShippingMin: { type: Number, attribute: 'free-shipping-min' },
    freeShippingEnabled: { type: String, attribute: 'free-shipping-enabled', reflect: true },
    enabledText: { type: String, attribute: 'enabled-text' },
    subscriptionItemsTotalQuantity: { type: Number },
    testOffer: { type: Boolean },
  }

  connectedCallback() {
    super.connectedCallback()
    this.subtotal = this.subtotal ?? 0
    this.freeShippingMin = this.freeShippingMin ?? 75
    this.freeShippingEnabled = this.freeShippingEnabled ?? 'false'
    this.enabledText = this.enabledText ?? `You've unlocked FREE US shipping!`
    this.subscriptionItemsTotalQuantity = this.subscriptionItemsTotalQuantity ?? 0
    this.testOffer = this.testIsControl ?? false
  }

  _renderFreeShippingText() {
    if (this.enabledText !== 'false') {
      const spendToFreeShipping = Math.round(this.freeShippingMin - this.subtotal)
      if (this.subtotal > this.freeShippingMin || this.freeShippingEnabled == 'true') {
        return html`<p>${this.enabledText}</p>`
      } else {
        return html`<p>Spend $${spendToFreeShipping} or subscribe to unlock FREE US shipping.</p>`
      }
    }
  }

  render() {
    if (this.testOffer == 'true') {
      return html`
        <div
          class="free-shipping-progress"
          shipping-progress-enabled="${this.subscriptionItemsTotalQuantity > 0 ? 'false' : 'true'}"
        >
          <div class="free-shipping-progress-bar">
            <progress-bar
              value=${this.freeShippingEnabled == 'true' ? 100 : Math.round((this.subtotal / this.freeShippingMin) * 100)}
            ></progress-bar>
          </div>
          ${this._renderFreeShippingText()}
        </div>
      `
    } else {
      return html`
        <div class="free-shipping-progress">
          <div class="free-shipping-progress-bar">
            <progress-bar
              value=${this.freeShippingEnabled == 'true' ? 100 : Math.round((this.subtotal / this.freeShippingMin) * 100)}
            ></progress-bar>
          </div>
          ${this._renderFreeShippingText()}
        </div>
      `
    }
  }
}
customElements.define('free-shipping-progress', FreeShippingProgress)
